@if (label) {
  <span
    class="container-select-label form-control-label"
    [class.required]="required()"
  >
    {{ label }}
  </span>
}
<p-select
  [options]="containerList"
  [multiple]="true"
  [filter]="true"
  filterBy="label"
  [disabled]="disabled()"
  [ngModel]="selectedContainers"
  (ngModelChange)="selectedContainers = $event; onContainersChange()"
  panelStyleClass="p-select-checkbox-options"
  placeholder="Select"
  [appendTo]="appendTo()"
  [lazy]="true"
  (onHide)="touched = true"
  [class]="hasError() ? 'has-error' : ''"
>
  <ng-template #item let-option>
    <p-checkbox
      [ngModel]="isSelected(option.value)"
      [binary]="true"
      [readonly]="true"
      [tabindex]="-1"
    />
    <span>{{ option.label }}</span>
  </ng-template>

  <ng-template #selectedItem>
    <app-selected-chips
      [items]="selectedContainers"
      [label]="chipLabel"
      [removable]="!disabled()"
      (removeItem)="removeContainer($event)"
    />
  </ng-template>
</p-select>
